module.exports = __webpack_public_path__ + "static/media/RoundedRect_Grey@3x.f8235011.png";